<!--
TODO
* Transitions/animations
  * To views
  * To filters @ results view
  * To filterSelection (change/close|enter differently)
* Add awaits/async stuff, too fast so it fails / loads some other endpoint first and gets messed
* Refactor
-->
<template>
  <!--<div :key="$route.fullPath">-->
  <div class="search">
    <div :class="['wrap', notes !== false ? 'wrap--mask' : '']">
      <div class="search__wrap">
        <div
          v-if="selectedFilters.projects"
          class="search__results search__results--front"
          style="padding-bottom: 0.1rem;"
        >
          <FormSubmit
            class="search__notes_button"
            variant="dark"
            :icon="icon"
            @click="showNotes()"
          >
            Show project notes
          </FormSubmit>
        </div>
        <div class="search__content">
          <div
            v-if="$route.name === 'Search' || $route.name === 'Datasets'"
            :key="'SEARCH_DATASETS_' + searchToken.datasets + ($route.name === 'Search' ? '_FIRST' : '_ALL')"
            :class="['search__datasets', 'search__results', $route.name === 'Search' ? 'search__results--front' : '']"
          >
            <AppDatasets
              title="Datasets"
              :results="results.datasets"
              :paginator="meta.datasets.paginator"
              :loading="loading.datasets"
              :timeout="timeout.datasets"
              :noResults="noResults.datasets"
              @itemClicked="itemClicked"
              @controlsChanged="toggleControls"
              @paginatorChanged="datasetsPaginatorChanged"
            />
          </div>

          <div
            v-if="$route.name === 'Search' || $route.name === 'PDFs'"
            :key="'SEARCH_PDFS_' + ($route.name === 'Search' ? '_FIRST' : '_ALL')"
            :class="['search__pdfs', 'search__results', $route.name === 'Search' ? 'search__results--front' : '']"
          >
            <AppPDFs
              title="Reports"
              :results="$route.name === 'Search' ? results.pdfs : results.pdfs"
              :paginator="meta.pdfs.paginator"
              :loading="loading.pdfs"
              :timeout="timeout.pdfs"
              :noResults="noResults.pdfs"
              @itemClicked="itemClicked"
              @controlsChanged="toggleControls"
              @paginatorChanged="PDFsPaginatorChanged"
            />
          </div>

          <div
            v-if="($route.name === 'Search' || $route.name === 'News') && !selectedFilters.projects"
            :key="'SEARCH_NEWS_' + ($route.name === 'Search' ? '_FIRST' : '_ALL')"
            :class="['search__news', 'search__results', $route.name === 'Search' ? 'search__results--front' : '']"
          >
            <AppNews
              :key="'SEARCH_NEWS_' + ($route.name === 'Search' ? '_FIRST' : '_ALL')"
              title="News"
              :results="$route.name === 'Search' ? results.news : results.news"
              :paginator="meta.news.paginator"
              :loading="loading.news"
              :timeout="timeout.news"
              :noResults="noResults.news"
              @itemClicked="itemClicked"
              @controlsChanged="toggleControls"
              @paginatorChanged="newsPaginatorChanged"
            />
          </div>

          <div
            v-if="$route.name === 'News' && selectedFilters.projects"
            :key="'SEARCH_NEWS_PROJECTS_VIEW'"
            :class="['search__news', 'search__results']"
          >
            <AppNews
              :key="'SEARCH_NEWS_PROJECTS'"
              title="News"
              :results="{allIds: ['project'], byId: {project: {attributes: {title: 'News are disabled when projects are selected.'}}}}"
              :paginator="false"
              :loading="false"
              :timeout="false"
              :noResults="false"
              @itemClicked="itemClicked"
              @controlsChanged="toggleControls"
              @paginatorChanged="newsPaginatorChanged"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="notes !== false"
      class="overlay"
    >
      <transition
        name="popup__transition"
        mode="out-in"
        appear
      >
        <div class="popup">
          <div class="popup__header">
            <h5>Project notes</h5>

            <div class="popup__close">
              <UtilityIconButton
                size="md"
                variant="round"
                backgroundColor="#12130f"
                highlightColor="rgba(255,255,255,0.7)"
                highlightBackgroundColor="#070806"
                content="Close"
                v-tippy="{ theme: 'statzon', placement: 'left', arrow: true, animation: 'scale' }"
                @click.native="notes = false"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23 20.168l-8.185-8.187 8.185-8.174-2.832-2.807-8.182 8.179-8.176-8.179-2.81 2.81 8.186 8.196-8.186 8.184 2.81 2.81 8.203-8.192 8.18 8.192z"/></svg>
              </UtilityIconButton>
            </div>
          </div>
          <div class="row row--separator row--border">
            <div class="row__full">
              <FormSelect
                v-model="selectedProject"
                :options="projectOptions"
                :disabled="projectOptions && projectOptions.length === 1"
                :icon="icon"
                dropdownHeight="170px"
                label="Select project"
                alt-label="Select project"
                class="projects__show"
              />
            </div>
          </div>
          <div class="popup__notes">
            <div class="row row--separator row--border">
              <div class="row__full">
                <p
                  v-if="selectedProject.key && notesByProject['PROJECT_' + selectedProject.key]"
                  v-html="notesByProject['PROJECT_' + selectedProject.key]"
                  style="white-space: pre-wrap; width: 100%; text-align: left;"
                />
                <i v-else>
                  No notes are written for this project...
                </i>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import AppDatasets from '@/components/app/Datasets.vue'
import AppPDFs from '@/components/app/PDFs.vue'
import AppNews from '@/components/app/News.vue'
import FormSelect from '@/components/form/Select.vue'
import FormSubmit from '@/components/form/Submit.vue'
import UtilityIconButton from '@/components/utility/IconButton.vue'
import helperMethods from '@/helpers/utility.js'
import { downloadPost } from '@/helpers/http'

export default {
  components: {
    AppDatasets,
    AppPDFs,
    AppNews,
    FormSelect,
    FormSubmit,
    UtilityIconButton
  },
  metaInfo () {
    return {
      title: 'Statzon App | Global Industry & Technology Insights & Data',
    }
  },
  data () {
    return {
      initialized: false,
      loading: {
        datasets: true,
        pdfs: true,
        news: true
      },
      timeout: {
        datasets: false,
        pdfs: false,
        news: true
      },
      noResults: {
        datasets: false,
        pdfs: false,
        news: false
      },
      notes: false,
      selectedProject: '',
      projectOptions: [],
      notesByProject: {},
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M11 5c-1.629 0-2.305-1.058-4-3h-7v20h24v-17h-13zm3.599 12l-2.599-1.39-2.599 1.39.518-2.902-2.125-2.042 2.921-.404 1.285-2.652 1.285 2.652 2.921.404-2.125 2.042.518 2.902z"/></svg>',
    }
  },
  computed: {
    isAuthenticated () {
      return this.$store.getters['user/isAuthenticated']
    },
    getSubscriptionStatus () {
      return this.$store.getters['user/getSubscriptionStatus']
    },
    searchToken () {
      return this.$store.getters['search/getSearchToken']
    },
    selectedView () { // TODO: Not used?
      return this.$store.getters['search/getSelectedView']
    },
    selectedHash () {
      return this.$store.getters['search/getSelectedHash']
    },
    results () {
      return this.$store.getters['search/getResults']
    },
    selectedFilters () {
      return this.$store.getters['search/getSelectedFilters']
    },
    selectedFiltersCount () {
      let query = false
      let filters = 0

      if (this.selectedFilters) {
        for (const [key, value] of Object.entries(this.selectedFilters)) {
          if (this.selectedFilters[key] && this.selectedFilters[key].length > 0) {
            if (key === 'queries') {
              query = true
            } else {
              filters += this.selectedFilters[key].length
            }
          }
        }
      }

      return (query === true ? 'Freetext' : '') + (query && filters > 0 ? ' + ' : '') + (filters > 0 ? filters + (filters === 1 ? ' filter' : ' filters') : '')
    },
    meta () {
      return this.$store.getters['search/getMeta']
    },
    pageTitle () {
      let title = 'Search'

      /* TODO: Redo, not working anymore...
      if (this.selectedView === 'search') {
        title = 'Search / Page ' + this.meta.paginator.current_page
      } else if (this.selectedView === 'datasets') {
        let resourceTitle = this.selectedHash !== false ? ' / ' + this.results.byId[this.selectedHash].attributes.title : ''
        title = 'Dataset' + resourceTitle
      } else if (this.selectedView === 'pdfs') {
        let resourceTitle = this.selectedHash !== false ? ' / ' + this.results.byId[this.selectedHash].attributes.title : ''
        title = 'PDF' + resourceTitle
      } else if (this.selectedView === 'filters') {
        let fixedFilters = { 'topics': 'Topics', 'locations': 'Locations', 'trade_types': 'Trades', 'scales': 'Scales', 'providers': 'Providers' }
        title = fixedFilters[this.activeFilter] + ' / Page ' + this.filtersMeta.current_page
      }*/

      return title
    }
  },
  watch: {
    $route (to, from) {
      let analytics = true
      this.initialize()

      if (to.name === 'Datasets' || to.name === 'Search') {
        this.search('datasets', false, analytics)
        analytics = false
      } if (to.name === 'PDFs' || to.name === 'Search') {
        this.search('pdfs', true, analytics)
        analytics = false
      } if (to.name === 'News' || to.name === 'Search') {
        this.search('news', true, analytics)
        analytics = false
      }
    }
  },
  methods: {
    search (type, silent, analytics) {
      // TODO: If this works, make new method to count only actual filters
      // WHICH filters/controls should we use? Doublecheck that API uses the same ones afterwards too...
      //console.log(this.$route.query.sort)
      if (Object.keys(this.selectedFilters).length > 0 && this.$route.query.sort === undefined) {
        this.$store.dispatch('app/setSettings', { 'name': type + '.sort', 'value': 'relevance' })
      }

      this.$store.dispatch('search/setSearchToken', { 'type': type, 'url': false })

      if (!this.results[type] || this.searchToken[type] !== this.meta[type].parameters.search_token) {
        this.$store.dispatch('search/fetchResults', type).then(response => {
          let checkResults = this.results[type]
          this.loading[type] = false

          if (checkResults.allIds.length === 0) {
            this.noResults[type] = true
            this.timeout[type] = false
          } else {
            this.noResults[type] = false
            this.timeout[type] = false
          }

          if (!silent) {
            this.$router.push('/'+ type + '?' + this.$store.getters['search/getFiltersQuery']('search', 'client') + this.$store.getters['search/getControlsQuery'](type, 'client'))
          }

          if (analytics && this.$store.getters['search/getFiltersQuery']('search', 'client') !== '') {
            this.sendGoogleAnalyticsEvent('search_filters_count', this.selectedFiltersCount, this.$route.name, this.$store.getters['user/getSubscriptionStatus'])
          }

          if (this.$store.getters['search/getFiltersQuery']('search', 'client') !== '') {
            this.sendGoogleAnalyticsEvent('search_' + type, this.selectedFiltersCount, this.meta[type].paginator.total, this.$store.getters['user/getSubscriptionStatus'])
          }

          return true
        }).catch(error => {
          this.timeout[type] = true
          this.loading[type] = false
        })
      } else {
        this.timeout[type] = false
        this.loading[type] = false
      }

      return false
    },
    datasetsPaginatorChanged (newPage) {
      this.$store.dispatch('search/setPageNumber', { type: 'datasets', value: newPage })
      this.$router.push('/datasets?' + this.$store.getters['search/getFiltersQuery']('search', 'client') + this.$store.getters['search/getControlsQuery']('datasets', 'client'))
    },
    PDFsPaginatorChanged (newPage) {
      this.$store.dispatch('search/setPageNumber', { type: 'pdfs', value: newPage })
      this.$router.push('/pdfs?' + this.$store.getters['search/getFiltersQuery']('search', 'client') + this.$store.getters['search/getControlsQuery']('pdfs', 'client'))
    },
    newsPaginatorChanged (newPage) {
      this.$store.dispatch('search/setPageNumber', { type: 'news', value: newPage })
      this.$router.push('/news?' + this.$store.getters['search/getFiltersQuery']('search', 'client') + this.$store.getters['search/getControlsQuery']('news', 'client'))
    },
    itemClicked (value) {
      /* This only works with first item selection. Maybe component "linking" breaks when views are changed. Theses analytics events are now moved to LayoutGrid, UtilityList and UtilityRelatedSlider */
      // let name = this.results[value.type].byId[value.hash].attributes.title ? this.results[value.type].byId[value.hash].attributes.title : (this.results[value.type].byId[value.hash].attributes.name ? this.results[value.type].byId[value.hash].attributes.name : value.id)
      //this.sendGoogleAnalyticsEvent(value.type, 'Search Selection', name, false, this.$store.getters['user/isAuthenticated'], this.$store.getters['user/getSubscriptionStatus'])
    },
    toggleControls (setting, value) {
      let settingType = setting.split('.')[0]
      let settingName = setting.split('.')[1]

      if (setting !== 'datasets.download') {
        this.$store.dispatch('app/setSettings', { 'name': setting, 'value': value })
      }

      if (setting === 'datasets.download') {
        this.downloadAllAsExcel()
      }

      if (setting === 'search.view') {
        if (['search', 'datasets', 'pdfs', 'news'].includes(value)) {
          if (value === 'search') {
            this.$router.push('/' + value + '?' + this.$store.getters['search/getFiltersQuery']('search', 'client'))
          } else {
            this.$router.push('/' + value + '?' + this.$store.getters['search/getFiltersQuery']('search', 'client') + this.$store.getters['search/getControlsQuery'](value, 'client'))
          }
        }
      }

      if (settingName === 'display') {
        // TODO: This triggers API reload, figure out to change URL silently without breaking stuff (also related to @Karri's ticket)
        this.$router.push('/' + settingType + '?' + this.$store.getters['search/getFiltersQuery']('search', 'client') + this.$store.getters['search/getControlsQuery'](settingType, 'client'))
      }

      if (settingName === 'sort' || settingName === 'access') {
        this.$store.dispatch('search/setPageNumber', { type: settingType, value: 1 })
        this.$router.push('/' + settingType + '?' + this.$store.getters['search/getFiltersQuery']('search', 'client') + this.$store.getters['search/getControlsQuery'](settingType, 'client'))
      }
    },
    downloadAllAsExcel () {
      let datasets = []

      let results = this.$store.getters['search/getResults']

      if (results && results.datasets && results.datasets.allIds && results.datasets.allIds.length > 0) {
        results.datasets.allIds.forEach(function (id) {
          datasets.push(results.datasets.byId[id].id)
        })

        let parameters = {
          datasets: datasets
        }
  
        downloadPost('downloads/datasets', parameters).then(response => {
          let blob = new Blob([response.data])
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          var date = new Date()
          let fileName = 'statzon_' + date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate() + '_' + ('0' + date.getHours()).slice(-2) + ('0' + date.getMinutes()).slice(-2) + ('0' + date.getSeconds()).slice(-2) + '.xlsx'
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }).catch(error => {
          this.excelError = error.errors
        })
  
        this.sendGoogleAnalyticsEvent('download_datasets_mass', false, false, this.$store.getters['user/getSubscriptionStatus'])
      }
    },
    initialize () {
      this.loading = {
        'datasets': true,
        'pdfs': true,
        'news': true
      }

      let parsedQuery = this.$store.getters['search/parseQuery'](true)
      let view = this.$route.name.toLowerCase()
      this.$store.dispatch('app/setSettings', { 'name': 'search.view', 'value': view })
      this.$store.dispatch('search/setPageNumber', { type: view, value: parsedQuery.controls.page ? parsedQuery.controls.page : 1 })
      this.$store.dispatch('search/setSelectedFilters', parsedQuery.filters)

      if (Object.keys(parsedQuery.controls).length > 0) {
        Object.keys(parsedQuery.controls).forEach(function (key) {
          if (parsedQuery.controls[key] !== false) {
            this.$store.dispatch('app/setSettings', { 'name': view + '.' + key, 'value': parsedQuery.controls[key] })
          } else if (key !== 'after_id' && key !== 'before_id') {
            this.$store.dispatch('app/setSettings', { 'name': view + '.' + key, 'value': 'all' })
          }
          // TODO: u need to add default otherwise -> load defaults as base first /deep/ add all params always not just set ones
        }.bind(this))
      }
    },
    showNotes () {
      let first = true
      this.projectOptions = []
      this.notesByProject = {}
      let projects = this.selectedFilters.projects
      if (projects && projects.length > 0) {
        projects.forEach(project => {
          if (first) {
            this.selectedProject = {
              key: project.id,
              name: project.attributes.name
            }
            first = false
          }
          this.projectOptions.push({
            key: project.id,
            name: project.attributes.name
          })
          this.notesByProject['PROJECT_' + project.id] = project.attributes.notes
        })
      }
      
      this.notes = true
    },
    ...helperMethods
  },
  mounted () {
    this.initialize()
    this.search('datasets', true, false)
    this.search('pdfs', true, false)
    this.search('news', true, false)
    this.sendGoogleAnalyticsEvent('search_filters_count', this.selectedFiltersCount, this.$route.name, this.$store.getters['user/getSubscriptionStatus'])
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.search {
  width: 100%;
  height: auto;
  margin: 0 auto 64px auto;

  @media screen and (min-width: $breakpointSm) {
    margin: 0 auto 464px auto;
  }

  .search__results--front {
    &:hover /deep/.controls {
      .button {
        background-color: $bg-1;
      }

      .button__icon {
        fill: $blue;
      }

      .button__text-icon {
        color: $white;
      }
    }
  }

  &__wrap {
    width: 100%;
    max-width: $xlContentWidth;
    margin: 144px auto 60px auto;

    @media screen and (min-width: $breakpointSm) {
      width: calc(100% - 32px);
      margin: 100px auto 60px auto;
    }

    @media screen and (min-width: $breakpointLg) {
      margin: 108px auto 68px auto;
    }
  }

  &__content {
    border-width: 1px 1px 0 1px;
    border-color: $black;
    border-style: solid;
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23); // TODO: Tweak...
  }

  &__notes_button {
    margin-bottom: 0.5rem;
  }
}

.overlay {
  position: fixed;
  z-index: 10;
  top: 100px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 100%;
  max-width: 600px;
}

.wrap {
  &--mask {
    transition: opacity 0.25s ease-out;
    opacity: 0.1;
  }
}

.popup {
  @include font('content--md', $white, 0.9);
  position: absolute;
  top: 0px;
  width: 100%;
  height: auto;
  text-align: center;
  height: auto;
  background-color: $bg-3;
  border: 1px solid $black;

  @media screen and (min-width: $breakpointLg) {
    @include font('content--lg', $white, 0.9);
  }

  &__notes {
    max-height: calc(100vh - 266px);
    overflow: hidden auto;
  }

  &__transition {
    &-enter-active, &-leave-active {
      transition: opacity 0.25s ease-out, transform 0.25s ease-out;
      transform: scale(1);
    }

    &-enter, &-leave-to {
      opacity: 0;
      transform: translateY(-20%) scale(0.6);
    }
  }

  &__header {
    display: flex;
    justify-content: space-between;
    background-color: $bg-2;
    padding: 8px 12px 8px 16px;
    border-top: 1px solid rgba($white, 0.1);
    border-bottom: 1px solid $black;

    h5 {
      @include font('header--sm');
      text-transform: uppercase;
    }
  }

  &__top {
    display: flex;
    justify-content: space-between;
    padding: 0.4rem 1rem;
    border-top: 1px solid rgba($white, 0.1);
    border-bottom: 1px solid $black;

    &--light {
      color: rgba($white, 0.7);
    }

    &--danger {
      color: $danger;
    }

    &--warning {
      color: $warning;
    }
  }

  &__info {
    margin: 0rem auto;
    padding: 0.75rem 1.5rem 1.25rem 1.5rem;
    border-top: 1px solid rgba($white, 0.1);
    border-bottom: 1px solid $black;
    color: rgba($white, 0.9);

    p {
      margin: 0;
      padding: 0;
    }
  }

  &__form {
    border-top: 1px solid rgba($white, 0.1);
  }

  &__tooltip {
    svg {
      position: relative;
      top: 3px;
      left: 3px;
      width: 18px;
      height: 18px;
      fill: rgba($white, 0.7);

      @media screen and (min-width: $breakpointLg) {
        width: 20px;
        height: 20px;
        top: 4px;
      }

      &:hover {
        fill: rgba($blue, 1);
      }
    }
  }
}
.row {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin: 0.75rem auto;
  padding: 0rem 1rem;

  @media screen and (min-width: $breakpointLg) {
    margin: 1rem auto;
  }

  &--border {
    border-bottom: 1px solid $black;
    margin: 0.75rem auto 0 auto !important;
    padding-bottom: 1rem !important;
  }

  &--separator {
    border-top: 1px solid rgba($white, 0.1);
    padding: calc(1rem - 1px) 1rem 0 1rem;
    margin: 0 !important;

    &Top {
      margin-top: 0.5rem;
    }
  }

  &__full {
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;

    &--filters {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
    }

    &--condensed {
      justify-content: space-around;
    }
  }

  &__left {
    flex: 0.2;
    text-align: left;
  }

  &__right {
    flex: 0.8;
    text-align: left;
  }

  &__notice {
    color: rgba($white, 0.5);
    margin: 0 auto 1rem auto;
    display: block;
    font-style: italic;
  }

  &__center {
    margin: 0 auto;
    display: block;
  }

  &__error {
    color: $red;
    margin: 0;
  }

  &__label {
    color: rgba($white, 0.9);
    text-align: left;
  }

  &__operator {
    @include font('content--xs', $white, 0.5);
    position: relative;
    z-index: 9;
    font-weight: 500;
    margin: 0px 3px;
    text-transform: uppercase;
    display: inline-flex;

    /deep/ span {
      color: rgba($white, 0.7) !important;
    }

    &--active {
      color: rgba($white, 0.7);
    }
  }

  &__filter {
    position: relative;
    z-index: 10;
  }
}
</style>
